export default {
    formId: 'createTerminalForm', //'createTerminalForm',
    formField: {
      name: {
        name: 'name',
        label: 'Nombre terminal*',
        requiredErrorMsg: 'El nombre terminal es requerido.'
      },
      description: {
        name: 'description',
        label: 'Descripcion*',
        requiredErrorMsg: 'La descripcion es requerida.'
      },
      typeTerminal: {
        name: 'typeTerminal',
        label: 'Tipo terminal',
        requiredErrorMsg: 'El tipo de terminal es requerida.'
      },
    }
};
  